import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import userinfor from './user.js'
import admin from './admin.js'
const store = new Vuex.Store({
    state: {
        Errornumber: "",
        Errormessage: "",
    },
    modules: {
        userinfor,
        admin,
    }

})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js